<template>
  <div class="card-wrapper width-full">
    <slot name="title"> </slot>
    <md-calendar
      class="bg-FFFFFF"
      v-model="modelDefaultDate"
      :format="format"
      @getDate="getDate"
      @change="swipeChange"
      @changeCalendarType="changeCalendarType"
      :minDate="minDate"
      :maxDate="maxDate"
      :with-status="withStatus"
      :status-list="dataStatusList"
      :international="false"
    >
    </md-calendar>
  </div>
</template>
<script>
import { timeFormat, timeStrToDate } from '@/utils/comUtils'
export default {
  props: {
    defaultDate: {
      type: Date,
      default() {
        return new Date()
      }
    },
    calendarMode: {
      type: Number,
      default: 0 // 0-周日历 1-月日历
    },
    timeFormat: {
      type: String,
      default: 'YYYY/MM/DD'
    },
    withStatus: {
      type: Boolean,
      default: false
    },
    statusList: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data() {
    return {
      format: 'YYYYMMDD',
      calendarType: this.calendarMode,
      timeStr: '',
      modelDefaultDate: null,
      dataStatusList: [],
      maxDate: new Date()
    }
  },
  created() {
    this.modelDefaultDate = this.defaultDate
    this.init()
  },
  computed: {
    minDate() {
      const today = new Date()
      return new Date(today.setFullYear(today.getFullYear() - 1))
    }
  },
  watch: {
    statusList(newValue) {
      if (newValue && newValue.length) {
        this.dataStatusList = newValue
      } else {
        this.dataStatusList = []
      }
    }
  },
  methods: {
    init() {
      let _targetDate = new Date(this.defaultDate.getTime())
      if (this.calendarType) {
        _targetDate.setDate(1)
      } else {
        _targetDate.setDate(_targetDate.getDate() - _targetDate.getDay())
      }
    },
    changeCalendarType({ date, calendarType, startDate, endDate } = {}) {
      // 切换周/月历
      const selectedDate = date.replace(/-/gi, '')
      let _startDate = startDate.replace(/\//gi, '')
      this.calendarType = calendarType
      this.$emit('changeCalendarType', {
        date: selectedDate,
        startDate: _startDate,
        endDate: endDate.replace(/\//gi, ''),
        calendarType: this.calendarType,
        exceed:
          +_startDate < +timeFormat(this.minDate, 'YYYYMMDD') ||
          +_startDate > +timeFormat(this.maxDate, 'YYYYMMDD')
      })
    },
    // 是否滑动
    swipeChange({ startDate = '', endDate = '' } = {}) {
      this.dataStatusList = []
      let _startDate = startDate.replace(/\//gi, '')
      // this.selectedDate = _startDate

      this.$emit('onTransitionEnd', {
        date: _startDate,
        startDate: _startDate,
        endDate: endDate.replace(/\//gi, ''),
        calendarType: this.calendarType,
        exceed:
          +_startDate < +timeFormat(this.minDate, 'YYYYMMDD') ||
          +_startDate > +timeFormat(this.maxDate, 'YYYYMMDD')
      })
    },
    // 选择日期
    getDate(date) {
      const selectedDate = date.replace(/-/gi, '')
      let testType = timeStrToDate(date)
      this.timeStr = timeFormat(testType, 'YYYY年MM月')
      this.$emit('getDate', selectedDate)
    }
  }
}
</script>
<style lang="scss" scoped>
.card-wrapper {
  .calendar-title {
    height: 40px;
    font-size: 15px;
    color: rgba(25, 31, 37, 0.6);
    background: #ffffff;
    border-bottom: 1px solid rgba(17, 31, 44, 0.12);
    .iconfont {
      color: #c7c7cc;
    }
  }
}
</style>
